<template>
  <div class="layout-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "LayoutMain",
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    key() {
      return this.$route.fullPath;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.layout-main {
  width: 100%;
  min-height: 500px;
  position: relative;
}
</style>
